// Central SEO configuration: site constants + keyword-to-page map.
// Each public route owns exactly one primary keyword/search intent to
// prevent multiple pages from competing for the same query (SEO cannibalization).
// Stage 2/3 pages (features/industries/solutions/resources) register their own
// SEO data locally via the <SEO> component's props instead of growing this map,
// since those are generated from per-page config objects — this map only covers
// the small set of pre-existing app routes wired in Stage 1.

export const SITE_NAME = "ServiceGuru Pro";

export const SITE_URL =
  typeof window !== "undefined" && window.location.origin
    ? window.location.origin
    : "https://servicegurupro.com";

export const DEFAULT_OG_IMAGE = "/servicegurupro-logo.png";

export const PAGE_SEO = {
  "/": {
    title: "Home Service CRM & Field Service Management Software | ServiceGuru Pro",
    description:
      "ServiceGuru Pro is a home service CRM and field service management platform with an AI voice assistant that schedules jobs, follows up with customers, and keeps HVAC, plumbing, electrical, pool, landscaping and roofing businesses moving. Start your 14-day free trial.",
    primaryKeyword: "home service CRM",
  },
  "/pricing": {
    title: "Pricing | ServiceGuru Pro Home Service CRM",
    description:
      "Simple, transparent pricing for ServiceGuru Pro's home service CRM and field service management platform. Compare plans and start a 14-day free trial — no credit card required.",
    primaryKeyword: "home service CRM pricing",
  },
  "/signup": {
    title: "Start Your Free Trial | ServiceGuru Pro",
    description:
      "Start a 14-day free trial of ServiceGuru Pro — the home service CRM with AI voice agents, dispatching, estimates, invoicing and payroll built for contractors. No credit card required.",
    primaryKeyword: "home service CRM free trial",
  },
  "/login": {
    title: "Log In | ServiceGuru Pro",
    description:
      "Log in to your ServiceGuru Pro account to manage jobs, dispatch, estimates, invoices and your team.",
    robots: "noindex, follow",
  },
  "/register": {
    title: "Create Your Account | ServiceGuru Pro",
    description: "Create your ServiceGuru Pro account to start managing your home service business.",
    robots: "noindex, follow",
  },
  "/privacy": {
    title: "Privacy Policy | ServiceGuru Pro",
    description:
      "Read the ServiceGuru Pro privacy policy to learn how we collect, use, and protect your business and customer data.",
  },
  "/terms": {
    title: "Terms of Service | ServiceGuru Pro",
    description:
      "Read the ServiceGuru Pro terms of service governing use of our home service CRM and field service management platform.",
  },
  "/become-an-affiliate": {
    title: "Become an Affiliate | ServiceGuru Pro Partner Program",
    description:
      "Join the ServiceGuru Pro affiliate program and earn commission referring home service businesses to an AI-powered field service CRM.",
    primaryKeyword: "ServiceGuru Pro affiliate program",
  },
};

export function getPageSeo(pathname) {
  return PAGE_SEO[pathname] || null;
}
